import { L as LOADING_ATTR_SYMBOL, N as NAMESPACE_HTML, D as get_prototype_of, F as get_descriptors, G as props_id, p as push, d as template, c as user_derived, m as child, f as template_effect, z as clsx, j as store_get, h as append, i as pop, s as setup_stores, b as get, g as getConsentInstance, y as sibling } from './consent.js';
import { d as delegate, s as set_text } from './render.js';
import { p as prop, s as set_class } from './props.js';

const IS_CUSTOM_ELEMENT = Symbol('is custom element');
const IS_HTML = Symbol('is html');

/**
 * @param {Element} element
 * @param {boolean} checked
 */
function set_checked(element, checked) {
	var attributes = get_attributes(element);

	if (
		attributes.checked ===
		(attributes.checked =
			// treat null and undefined the same for the initial value
			checked ?? undefined)
	) {
		return;
	}

	// @ts-expect-error
	element.checked = checked;
}

/**
 * @param {Element} element
 * @param {string} attribute
 * @param {string | null} value
 * @param {boolean} [skip_warning]
 */
function set_attribute(element, attribute, value, skip_warning) {
	var attributes = get_attributes(element);

	if (attributes[attribute] === (attributes[attribute] = value)) return;

	if (attribute === 'loading') {
		// @ts-expect-error
		element[LOADING_ATTR_SYMBOL] = value;
	}

	if (value == null) {
		element.removeAttribute(attribute);
	} else if (typeof value !== 'string' && get_setters(element).includes(attribute)) {
		// @ts-ignore
		element[attribute] = value;
	} else {
		element.setAttribute(attribute, value);
	}
}

/**
 *
 * @param {Element} element
 */
function get_attributes(element) {
	return /** @type {Record<string | symbol, unknown>} **/ (
		// @ts-expect-error
		element.__attributes ??= {
			[IS_CUSTOM_ELEMENT]: element.nodeName.includes('-'),
			[IS_HTML]: element.namespaceURI === NAMESPACE_HTML
		}
	);
}

/** @type {Map<string, string[]>} */
var setters_cache = new Map();

/** @param {Element} element */
function get_setters(element) {
	var setters = setters_cache.get(element.nodeName);
	if (setters) return setters;
	setters_cache.set(element.nodeName, (setters = []));

	var descriptors;
	var proto = element; // In the case of custom elements there might be setters on the instance
	var element_proto = Element.prototype;

	// Stop at Element, from there on there's only unnecessary setters we're not interested in
	// Do not use contructor.name here as that's unreliable in some browser environments
	while (element_proto !== proto) {
		descriptors = get_descriptors(proto);

		for (var key in descriptors) {
			if (descriptors[key].set) {
				setters.push(key);
			}
		}

		proto = get_prototype_of(proto);
	}

	return setters;
}

function handleChange(e, instance) {
	const target = e.target;

	get(instance).setConsent(target.checked);
}

var root = template(`<div><input type="checkbox" value="consent"> <label> </label></div>`);

function ConsentWidget($$anchor, $$props) {
	const id = props_id();

	push($$props, true);

	const [$$stores, $$cleanup] = setup_stores();
	const $value = () => store_get(get(value), '$value', $$stores);

	let isDisabled = prop($$props, 'disabled', 3, false),
		classInput = prop($$props, 'class-input', 3, 'checkbox__input checkradio__input'),
		classLabel = prop($$props, 'class-label', 3, 'checkbox__label checkradio__label'),
		classWrapper = prop($$props, 'class-wrapper', 3, 'checkbox checkbox--is-block checkradio checkradio--block checkradio--checkbox');

	const instance = user_derived(() => getConsentInstance($$props.key, $$props.type));
	const value = user_derived(() => get(instance).store);
	var div = root();
	let classes;
	var input = child(div);
	set_attribute(input, 'id', id);
	input.__change = [handleChange, instance];

	var label = sibling(input, 2);

	set_attribute(label, 'for', id);

	var text = child(label);

	template_effect(
		($0) => {
			classes = set_class(div, 1, clsx(classWrapper()), null, classes, $0);
			set_class(input, 1, clsx(classInput()));
			set_checked(input, $value());
			set_attribute(input, 'aria-disabled', isDisabled());
			set_class(label, 1, clsx(classLabel()));
			set_text(text, $value() ? $$props['label-revoke-consent'] : $$props['label-give-consent']);
		},
		[
			() => ({ 'checkradio--disabled': isDisabled() })
		]
	);

	append($$anchor, div);
	pop();
	$$cleanup();
}

delegate(['change']);

export { ConsentWidget as default };
//# sourceMappingURL=ConsentWidget.js.map
